if ($('#routes_table').length) {

    let url = window.location.origin + '/routes/get';

    setTimeout(function () {
        modules_table();
    }, 500);

    function modules_table() {
        $('#routes_table').dataTable({
            "processing": true,
            "serverSide": true,
            "ajax": url,
            "columns": [
                {data: 'description'},
                {data: 'status'},
            ],
            //"order": [[3, 'asc']],
            "columnDefs": [
                {width: '55%', targets: 0},
                {width: '30%', targets: 1},
                {width: '15%', targets: 2},
                {
                    "targets": 1,
                    "render": function (data, type, row, meta) {
                        if (row.status === Status.ACTIVO) {
                            return "<span class='badge badge-success'><big>Activo</big></span>";
                        } else {
                            return "<span class='badge badge-danger'><big>Suspendido</big></span>";
                        }
                    }
                },
                {
                    "targets": 2,
                    "render": function (data, type, row, meta) {

                        return "<button type='button' class='btn btn-primary btn-sm edit-route' data-user='" + row + "' data-bs-toggle='tooltip' title='Editar Ruta'><i class='fas fa-pencil-alt'></i></button> "
                            + "<button type='button' class='btn btn-danger btn-sm remove-route' data-user='" + row + "' data-bs-toggle='tooltip' title='Eliminar Ruta'><i class='fas fa-trash'></i></button> ";

                    }
                }],
            "language": {
                "url": window.location.origin + "/json/Spanish.json"
            },
        });

        $('#routes_table').on('draw.dt', function () {
            $('[data-bs-toggle="tooltip"]').tooltip();
        });

        $('#routes_table tbody').on('click', '.edit-route', function (e) {
            e.preventDefault();
            let table = $("#routes_table").DataTable();
            let rowData = table.row($(this).parents('tr')).data();

            $.ajax({
                url: window.location.origin + '/routes/' + rowData.id + '/edit',
                type: 'GET',
            })
                .done(function (response) {

                    document.getElementById('div_modal').innerHTML = response;
                    $('.chosen-select').chosen({width: '100%'});
                    $('#modal-route').modal("show");
                })
                .fail(function (jqXHR, textStatus) {
                    console.log(jqXHR);
                    alert("Disculpe, existió un problema");
                });
        });

        $('#routes_table tbody').on('click', '.remove-route', function (e) {
            e.preventDefault();
            let table = $("#routes_table").DataTable();
            let rowData = table.row($(this).parents('tr')).data();
            Swal
                .fire({
                    title: "Eliminar el ruta " + rowData.description,
                    text: "¿Eliminar?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: "Sí, eliminar",
                    cancelButtonText: "Cancelar",
                })
                .then(resultado => {
                    if (resultado.value) {
                        let url = window.location.origin + '/routes/' + rowData.id;
                        $.ajax({
                            url: url,
                            type: 'DELETE',
                            headers: {
                                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                            }
                        })
                            .done(function (response) {
                                Swal.fire('Eliminado', ' Se ha eliminado la ruta.', 'success')
                                    .then(() => {
                                        let url = window.location.origin + '/routes/get';
                                        $('#routes_table').DataTable().ajax.url(url).load();
                                    });
                            })
                            .fail(function (jqXHR, textStatus) {
                                console.log(jqXHR);
                                alert("Disculpe, existió un problema");
                            });
                    }
                });
        });

    }

    $(".add_routes").on('click', function () {

        $.ajax({
            url: window.location.origin + '/routes/create',
            type: 'GET',
        })
            .done(function (response) {
                document.getElementById('div_modal').innerHTML = response;
                $('.chosen-select').chosen({width: '100%'});
                $('#modal-route').modal("show");
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR);
                alert("Disculpe, existió un problema");
            });

    })

    $(document).on('submit', '#formRoutes', function (event) {

        event.preventDefault();

        let url = window.location.origin + '/routes';
        let formData = new FormData(this);
        document.getElementById('div_message').innerHTML = "";

        $.ajax({
            data: formData,
            url: url,
            type: 'POST',
            contentType: false,
            processData: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        })
            .done(function (response) {
                console.log(response)

                Swal.fire('Agregado', ' Se agrego la ruta correctamente', 'success')
                    .then(() => {
                        $('#modal-route').modal("hide");
                        let url = window.location.origin + '/routes/get';
                        $('#routes_table').DataTable().ajax.url(url).load();
                    });
            })
            .fail(function (jqXHR, textStatus) {
                //validacion de laravel a campos lo ignoramos unicamente por que entra en fail xk no pasa la validacion
                if (jqXHR['status'] == 422) {

                    let errors = "<ul class=''>";
                    let items = "";

                    $.each(jqXHR['responseJSON']['errors'], function (index, value) {
                        items = items + "<li class=''>" + value + "</li>";
                    });

                    errors = errors + items + "</ul>";
                    let view = "<div class='row'><div class='card-body'><div class='alert alert-danger alert-dismissible'>"
                        + "<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>×</button>"
                        + "<h5><i class='icon fas fa-ban'></i> Advertencia</h5>"
                        + errors
                        + "</div></div></div>";
                    document.getElementById('div_message').innerHTML = view;
                } else {
                    console.log(jqXHR['status']);
                    alert("Disculpe, existió un problema");
                }
            });
    });

    $(document).on('submit', '#formRoutesUpdate', function (event) {

        event.preventDefault();
        let id = $("#id").val();
        let url = window.location.origin + '/routes/' + id;
        let formData = new FormData(this);
        formData.append('_method', 'PUT');

        document.getElementById('div_message').innerHTML = "";
        $.ajax({
            data: formData,
            url: url,
            type: 'POST',
            contentType: false,
            processData: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        })
            .done(function (response) {
                if (typeof response['status'] !== 'undefined') {
                    Swal.fire('Advertencia', response['message'], 'info')
                        .then(() => {
                            location.reload();
                        });
                } else {
                    Swal.fire('Actualizado', 'Se actualizo el registro correctamente', 'success')
                        .then(() => {
                            $('#modal-route').modal("hide");
                            let url = window.location.origin + '/routes/get';
                            $('#routes_table').DataTable().ajax.url(url).load();
                        });
                }

            })
            .fail(function (jqXHR, textStatus) {
                //validacion de laravel a campos lo ignoramos unicamente por que entra en fail xk no pasa la validacion
                if (jqXHR['status'] == 422) {

                    let errors = "<ul class=''>";
                    let items = "";

                    $.each(jqXHR['responseJSON']['errors'], function (index, value) {
                        items = items + "<li class=''>" + value + "</li>";
                    });

                    errors = errors + items + "</ul>";
                    let view = "<div class='row'><div class='card-body'><div class='alert alert-danger alert-dismissible'>"
                        + "<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>×</button>"
                        + "<h5><i class='icon fas fa-ban'></i> Advertencia</h5>"
                        + errors
                        + "</div></div></div>";
                    document.getElementById('div_message').innerHTML = view;
                } else {
                    console.log(jqXHR['status']);
                    alert("Disculpe, existió un problema");
                }
            });
    });

}
